import { Twitter, Linkedin, User } from "lucide-react";
import { Link } from "react-router-dom";

import { useTranslation } from 'react-i18next';
const DEFAULT_AUTHOR = {
  name: "Max Employee Team",
  role: "AI Research & Product",
  bio: "The Max Employee team builds AI digital workers that transform how businesses operate. Follow us for insights on AI agents, automation, and the future of work.",
  avatar: null,
  social: {
    twitter: "https://twitter.com/maxemployee",
    linkedin: "https://www.linkedin.com/company/maxemployee",
  },
};

export default function AuthorBox({ author }) {
  const { t } = useTranslation();
  const a = author || DEFAULT_AUTHOR;

  return (
    <div
      className="border border-zinc-800 bg-zinc-900/50 p-4 sm:p-8 mt-8 sm:mt-12"
      aria-label={t('author_box.about_the_author')}
    >
      <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-5">
        {/* Avatar */}
        <div className="w-16 h-16 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center shrink-0 overflow-hidden">
          {a.avatar ? (
            <img
              src={a.avatar}
              alt={a.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <User className="w-8 h-8 text-zinc-500" aria-hidden="true" />
          )}
        </div>

        <div className="flex-1">
          {/* Name + role */}
          <div className="flex items-center gap-3 flex-wrap">
            <h4 className="font-display text-lg uppercase text-white">
              <Link
                to={`/blog/author/${encodeURIComponent(a.name)}`}
                className="hover:text-amber-500 transition-colors"
              >
                {a.name}
              </Link>
            </h4>
            {a.role && (
              <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-amber-500 bg-amber-500/10 px-2 py-0.5">
                {a.role}
              </span>
            )}
          </div>

          {/* Bio */}
          <p className="text-zinc-400 text-sm leading-relaxed mt-3">
            {a.bio}
          </p>

          {/* Social links */}
          <div className="flex items-center gap-3 mt-4">
            <a
              href={a.social?.twitter || "https://twitter.com/maxemployee"}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-zinc-500 hover:text-amber-500 transition-colors"
              aria-label={`${a.name} on Twitter`}
            >
              <Twitter className="w-4 h-4" />
              <span className="font-mono text-[10px] uppercase tracking-wider">
                @maxemployee
              </span>
            </a>
            <a
              href={
                a.social?.linkedin ||
                "https://www.linkedin.com/company/maxemployee"
              }
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-zinc-500 hover:text-amber-500 transition-colors"
              aria-label={`${a.name} on LinkedIn`}
            >
              <Linkedin className="w-4 h-4" />
              <span className="font-mono text-[10px] uppercase tracking-wider">
                LinkedIn
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
